/* PYA wave dividers: draws each divider's edge from overlapping travelling sine waves
   (see sections/pya-wave-divider.liquid). Animates only on screen, never in the theme editor
   preview's hidden tabs, and draws a single still frame for reduced-motion users. */
(function () {
  'use strict';
  if (window.__pyaWaves) return;
  window.__pyaWaves = true;

  var W = 1200;
  var H = 80;
  var STEP = 40; // sample every 40 units: 31 points, smoothed with Catmull-Rom curves
  var TAU = Math.PI * 2;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(cfg, t) {
    var pts = [];
    for (var x = 0; x <= W; x += STEP) {
      var y = cfg.base;
      for (var i = 0; i < cfg.c.length; i++) {
        var c = cfg.c[i]; // [amplitude, wavelength, seconds per cycle, phase]
        y += c[0] * Math.sin((TAU * x) / c[1] - (TAU * t) / c[2] + c[3]);
      }
      pts.push([x, Math.max(2, Math.min(H - 6, y))]);
    }
    var d = 'M0 ' + pts[0][1].toFixed(1);
    for (var k = 0; k < pts.length - 1; k++) {
      var p0 = pts[k - 1] || pts[k];
      var p1 = pts[k];
      var p2 = pts[k + 1];
      var p3 = pts[k + 2] || p2;
      d +=
        ' C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) +
        ' ' + (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) +
        ' ' + p2[0] + ' ' + p2[1].toFixed(1);
    }
    return d + ' L' + W + ' ' + H + ' L0 ' + H + ' Z';
  }

  var items = [];
  var visible = new Set();
  var running = false;
  var start = performance.now();
  var last = 0;
  // The waves drift slowly, so 20 redraws a second look the same as 60 and cost a third of the work.
  var FRAME_MS = 50;
  // Hold the drift until the page has loaded so it doesn't compete with first paint.
  var ready = document.readyState === 'complete';

  function frame(now) {
    if (!visible.size) {
      running = false;
      return;
    }
    if (now - last < FRAME_MS) {
      requestAnimationFrame(frame);
      return;
    }
    last = now;
    var t = (now - start) / 1000;
    visible.forEach(function (it) {
      it.path.setAttribute('d', build(it.cfg, t + it.offset));
    });
    requestAnimationFrame(frame);
  }

  function kick() {
    if (ready && !running && visible.size) {
      running = true;
      requestAnimationFrame(frame);
    }
  }

  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              var it = e.target.__pyaWave;
              if (!it) return;
              if (e.isIntersecting) visible.add(it);
              else visible.delete(it);
            });
            kick();
          },
          { rootMargin: '100px 0px' }
        )
      : null;

  function init(el) {
    if (el.__pyaWave) return;
    var path = el.querySelector('.pya-wave__path');
    var cfg;
    try {
      cfg = JSON.parse(el.getAttribute('data-waves'));
    } catch (e) {
      return;
    }
    if (!path || !cfg || !cfg.c) return;
    // a different starting moment per divider so they don't move in lockstep
    var it = { el: el, path: path, cfg: cfg, offset: items.length * 3.7 };
    el.__pyaWave = it;
    items.push(it);
    path.setAttribute('d', build(cfg, it.offset));
    if (!reduced && el.hasAttribute('data-animate') && io) io.observe(el);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('.pya-wave[data-waves]'), init);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', function () {
    ready = true;
    kick();
  });
  // theme editor: sections re-render without a page load
  document.addEventListener('shopify:section:load', function () {
    items = items.filter(function (it) {
      if (document.contains(it.el)) return true;
      visible.delete(it);
      if (io) io.unobserve(it.el);
      return false;
    });
    scan();
  });
})();
